import { DEFAULT_LOCALE } from '@/constants';

export const dateFormat = 'DD/MM/YYYY';
export const timeFormat = 'HH:mm';

type DateTimeInput = string | null | undefined;

export const formatDateTime = (inputDate: DateTimeInput, locale = DEFAULT_LOCALE) => {
    if (inputDate === null || inputDate === undefined || inputDate === '') {
        return null;
    }

    const date = new Date(inputDate);
    if (Number.isNaN(date.getTime())) {
        return null;
    }

    const formatter = new Intl.DateTimeFormat(locale, {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
    });

    return formatter.format(date).toUpperCase();
};
